module.exports = __webpack_public_path__ + "561fa116c80f9c1ca24cc91fce1e15a1.png";